define('OutSystems/ClientRuntime/RolesService',["require", "exports", "./RolesInfo"], function (require, exports, RolesInfo_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getUserId = exports.checkRole = void 0;
    function checkRole(roleKey) {
        if (!RolesInfo_1.RolesInfoStorage.rolesInfo.isDefined()) {
            return false;
        }
        var rolesInfo = RolesInfo_1.RolesInfoStorage.rolesInfo.get();
        return rolesInfo.indexOf(roleKey) >= 0;
    }
    exports.checkRole = checkRole;
    exports.getUserId = RolesInfo_1.getUserId;
});
//# sourceMappingURL=RolesService.js.map;
